/**
 * @desc 创建任务
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(body: defs.report.FileDownloadTaskRpcRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/fileDownloadTask/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
